import { render, staticRenderFns } from "./FormSaveBtn.vue?vue&type=template&id=544b9397"
import script from "./FormSaveBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSaveBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports